import React, { FC, ChangeEvent, useState, useEffect } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';

type NumberOnlyTextFieldProps = {
    hasDecimal?: boolean;
    allowNegative?: boolean;
    maxLength?: number;
    notAllowZero?: boolean;
    onValueChange?: (value: string) => void;
} & TextFieldProps;

const NumberOnlyTextField: FC<NumberOnlyTextFieldProps> = ({
    label,
    onValueChange,
    allowNegative = false,
    hasDecimal = true,
    notAllowZero = false,
    maxLength = Number.MAX_SAFE_INTEGER,
    ...props
}: NumberOnlyTextFieldProps) => {
    const [value, setValue] = useState<string>('');
    let regexStr = hasDecimal ? '[0-9]*[,.]?[0-9]*$' : '[0-9]*$';
    regexStr = allowNegative ? `^-?${regexStr}` : `^${regexStr}`;
    if (notAllowZero) {
        regexStr = hasDecimal
            ? `^-?[1-9][0-9]*[,.]?[0-9]*$|^$` // Prevents leading zero and allows empty input
            : `^-?[1-9][0-9]*$|^$`; // Prevents leading zero and allows empty input without decimals
    }
    const numRegex = new RegExp(regexStr);
    const { value: _, ...remainingProps } = props;
    const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (!numRegex.test(value) || value.length > maxLength) {
            return event.preventDefault();
        }
        setValue(value);
        if (onValueChange) {
            onValueChange(value);
        }
    };

    useEffect(() => {
        setValue(props.value as string);
    }, [props.value]);

    return (
        <TextField
            label={label}
            onChange={onInputChange}
            {...remainingProps}
            value={value}
            type="text"
            margin="dense"
        />
    );
};

export default NumberOnlyTextField;
